import { env } from '@/env';

/**
 * 앱 내부 경로 → **배포된 web 앱의 절대 URL**. 현재 화면을 벗어나 여는 링크(구독·결제 흐름)에 쓴다.
 *
 * `window.location.origin` 을 쓰면 안 된다 — WebView 는 native scheme origin
 * (`app://app.heviton.local` iOS / `https://app.heviton.local` Android) 위에서 돌아, 그 origin 으로 만든
 * URL 은 시스템 브라우저로 넘겨봐야 열리지 않는다. 그래서 배포 도메인을 env(`deployBaseUrl`)가 소유한다.
 *
 * 열기 자체는 호출처가 `Navigator.openExternal` 로 — web=새 탭 / native=bridge(시스템 브라우저) 분기가
 * 거기 SSOT 로 있다(ADR navigator-service).
 *
 * `|| window.location.origin` 은 폴백 전략이 아니라 **크래시 가드**다 — 모든 env 가 값을 갖지만
 * (`*.local` 도 `http://localhost:5173`), 빈 문자열이 들어오면 `new URL(path, '')` 이 TypeError 를 던진다.
 */
export function deployUrl(path: string): string {
  return new URL(path, env.deployBaseUrl || window.location.origin).toString();
}
